import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class PasswordValidatorService {

  private regExPassword: RegExp = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,15}$/; // verifica toda la contraseña

  private hasCapitalCase: RegExp = /[A-Z]/; // verifica al menos una mayuscula
  private hasLowerCase: RegExp = /[a-z]/; // verifica al menos una minuscula
  private hasNumber: RegExp = /\d/; // verifica al menos un numero
  private passLength: RegExp = /^\w{8,15}$/; // verifica un largo de 8 a 15 caracteres

  validateEmail: RegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/

  passErrors: boolean = true;
  errorCapitalCase: boolean = true;
  errorLowerCase: boolean = true;
  errorHasNumber: boolean = true;
  errorPassLength: boolean = true;
  errorPassNotMatch: boolean = true;

  constructor() { }

  public checkPassword(password: string, confirmPassword: string) {
    const passVerify = this.regExPassword.test(password)

    if (this.hasCapitalCase.test(password)) this.errorCapitalCase = false
    else this.errorCapitalCase = true
    if (this.hasLowerCase.test(password)) this.errorLowerCase = false
    else this.errorLowerCase = true
    if (this.hasNumber.test(password)) this.errorHasNumber = false
    else this.errorHasNumber = true
    if (this.passLength.test(password)) this.errorPassLength = false
    else this.errorPassLength = true
    if (password === confirmPassword) this.errorPassNotMatch = false
    else this.errorPassNotMatch = true

    if (!this.errorCapitalCase && !this.errorLowerCase && !this.errorHasNumber
      && !this.errorPassLength && !this.errorPassNotMatch && passVerify) {
      this.passErrors = false
    } else {
      this.passErrors = true
    }
  }
}
